import type { FaireProductEntity } from "../../entity_types/product";

export const p_zw78634xqt: FaireProductEntity = {
  token: "p_zw78634xqt",
  type: "product",
  name: "Blonde Hinoki– HI-FI Reed Diffuser",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl: "https://cdn.faire.com/fastly/7046a5ac3e38f8e1a97a1c2e013a721621ec9f34690ee38fbc92df0bc73d8ce0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4357932b3a1affe864ff2c7fac52493a1b6fd9e9f2786179f85eb4c2c03f6528.jpeg",
    "https://cdn.faire.com/fastly/a02d43351354a6f550afa48801d3f5855cb932a09b4a5b9f7cce6300220c0b4d.jpeg",
    "https://cdn.faire.com/fastly/ec40e4ba6752d2f66cbd4a4d1ea2f59941c610694b461fbabded9965440ac9cb.jpeg",
    "https://cdn.faire.com/fastly/c2d752f665a1b3cc4b36fde26ed2ee173ac8b5f73edcc9ffe872dc28254790f6.jpeg",
    "https://cdn.faire.com/fastly/1869bdb5e4f8f91f588fb709c781af7097284dfca3b4a345e52fa33b78bfb1a3.jpeg"
  ],
  priceDollars: 19.5,
  description: "Inspired by the light woods used to house records in a hi-fi listening bar. Clean and warm, uplifted by aromatic greenery and eucalyptus.  Golden cypress, green petitgrain, and elemi resin.\n\nPRODUCT INFORMATION:\n\nEach diffuser contains a 4 fl oz blend of naturally-derived and man-made fragrance oils in a square custom cocoa brown glass bottle with a Vermilion debossed front label and packaged in a premium paper gift box.\n\nLasts approximately 3-4 months.\n\nIncludes a bundle of 9\" long naturally-harvested black dyed rattan reeds to absorb and slowly release the fragrance.",
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:58.642Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
